import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import ToolbarStickerPopover from './ToolbarStickerPopover';
import { ToolbarIcon } from '../ToolbarIcon';
import useIM from 'hooks/business/im/useIM';

export interface StickerPickerProps {
  conversation: Conversation.Conversation;
  onSend?: () => void;
  onEmojiChange: (emoji: any) => void;
}

export const StickerPicker = (props: StickerPickerProps) => {
  const {
    conversation: { conversationId, region, channel },
    onSend,
    onEmojiChange,
  } = props;
  const { sendSticker, sendImage } = useIM();

  return (
    <ToolbarStickerPopover
      region={region}
      platform={channel}
      showEmojiTab={isTiKTokUpperCase(channel)}
      onEmojiChange={onEmojiChange}
      onChange={(sticker) => {
        if (channel === 'TOKOPEDIA') {
          sendImage(
            conversationId,
            {
              imgUrl: sticker.imageUrl,
              externalImgUrl: sticker.imageUrl,
              width: 160,
              height: 160,
            },
            sticker.imageUrl,
          ).finally(() => {
            onSend && onSend();
          });
          return;
        }
        sendSticker(
          conversationId,
          {
            stickerId: sticker.raw.sid,
            stickerPackageId: sticker.raw.pid,
          },
          sticker.raw,
        )
          .then(() => {
            onSend && onSend();
          })
          .catch(() => {});
      }}
    >
      <ToolbarIcon icon="emoji" />
    </ToolbarStickerPopover>
  );
};
